import React from "react";
import { ImageFluid } from "../../../../../common-deprecated/styles/v2/toyota/globals/Image";
import * as Dropdown from "../../../../../common-deprecated/styles/v2/toyota/globals/Dropdown";
import Preloader from "../../../../../common-deprecated/styles/toyota/Preloader";
import { useCompareV2Selector } from "../../../redux/store";
import { getCompareImages } from "../../../../../shared-logic/features/compare/utils/helpers";
import SelectSwatch from "./SelectSwatch";
import * as CompareItemStyle from "../styles/CompareItem";
import HighlightedSpecs from "./HighlightedSpecs";
import { getCarName } from "../../../utils/formatters/nameFormatters";
import useCompareDetails from "../../../../../shared-logic/features/compare/hooks/useCompareDetails";
import SelectEngine from "./content/SelectEngine";
import EmptySlot from "./content/EmptySlot";
import CompareTable from "../../common/CompareTable";
import { NcCompareContext } from "../../../../../common-deprecated/types/NewCarCompareTypes";
import LeasingSpec from "./content/LeasingSpec";
import PriceSpec from "./content/PriceSpec";

const CompareDetails = (props: { isPdf?: boolean }): JSX.Element => {
    const { isPdf = false } = props;
    const cars = useCompareV2Selector((state) => state.newCarCompare.grades);
    const selectedEngines = useCompareV2Selector(({ newCarCompare }) => newCarCompare.selectedEngines);
    const showPrice = useCompareV2Selector((state) => state.commonSettings.showPrice);
    const commonSettings = useCompareV2Selector((state) => state.commonSettings);
    const isLeasing = useCompareV2Selector(
        (state) => state.newCarCompare.ncCompareContext === NcCompareContext.Leasing,
    );

    const { placeholderImage, swatchSelectHeight, setSwatchSelectHeight, engineSelectHeight, setEngineSelectHeight } =
        useCompareDetails(isPdf, cars, commonSettings);

    return (
        <>
            <CompareTable
                items={cars}
                placeholder={() =>
                    !isPdf && (
                        <CompareItemStyle.Wrapper>
                            <EmptySlot carImage={placeholderImage} />
                        </CompareItemStyle.Wrapper>
                    )
                }
                columnChild={(car) => {
                    const image = getCompareImages(car, commonSettings);
                    return (
                        <CompareItemStyle.Wrapper key={car.id}>
                            {isPdf && (
                                <Dropdown.Title isPdf={isPdf} showPointer={false} height={60}>
                                    {getCarName(car, commonSettings)}
                                </Dropdown.Title>
                            )}
                            <CompareItemStyle.Placeholder isLoading={car.loading}>
                                {car.loading ? (
                                    <Preloader />
                                ) : (
                                    <ImageFluid
                                        src={image.default}
                                        srcSet={image.set}
                                        sizes=""
                                        draggable={false}
                                        alt=""
                                    />
                                )}
                            </CompareItemStyle.Placeholder>
                        </CompareItemStyle.Wrapper>
                    );
                }}
            />

            {showPrice &&
                (isLeasing ? (
                    <CompareTable items={cars} columnChild={(car, index) => <LeasingSpec key={index} car={car} />} />
                ) : (
                    <CompareTable
                        items={cars}
                        columnChild={(car, index) => (
                            <PriceSpec key={index} car={car} motorization={selectedEngines[index]} />
                        )}
                    />
                ))}

            {!isLeasing && (
                <CompareTable
                    items={cars}
                    columnChild={(car, index) => {
                        return (
                            <CompareItemStyle.Wrapper key={car.id}>
                                <SelectSwatch
                                    availableColours={car.availableColours}
                                    selectedColourCode={car.colourCode}
                                    swatchSelectHeight={swatchSelectHeight}
                                    setSwatchSelectHeight={setSwatchSelectHeight}
                                    index={index}
                                />
                            </CompareItemStyle.Wrapper>
                        );
                    }}
                />
            )}
            <CompareTable
                items={cars}
                columnChild={(car, index) => {
                    return (
                        <CompareItemStyle.Wrapper key={car.id}>
                            <SelectEngine
                                isPdf={isPdf}
                                index={index}
                                engineSelectHeight={engineSelectHeight}
                                setEngineSelectHeight={setEngineSelectHeight}
                            />
                        </CompareItemStyle.Wrapper>
                    );
                }}
            />
            <HighlightedSpecs />
        </>
    );
};

export default CompareDetails;
